import { render, staticRenderFns } from "./sitecalibrationhealth.vue?vue&type=template&id=0bdcb3a1&scoped=true"
import script from "./sitecalibrationhealth.vue?vue&type=script&lang=js"
export * from "./sitecalibrationhealth.vue?vue&type=script&lang=js"
import style0 from "./sitecalibrationhealth.vue?vue&type=style&index=0&id=0bdcb3a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bdcb3a1",
  null
  
)

export default component.exports